import { createFileRoute } from '@tanstack/react-router';

import { QueryCreationPage } from '@/entities/query-builder/query-creation-page';

export const Route = createFileRoute('/workspace/$workspaceId/create-new')({
  component: QueryCreationPage,
});
